import { Component, OnInit } from '@angular/core';
import { UsersComponent } from '../users/users.component';
import { Router } from '@angular/router';
import { ProviderService } from '../services/providers/provider.service';
import { LoginAttemptService } from '../services/loginAttempts/loginAttempts.service';
import { RequestService } from '../services/request.service';
import { ResponseContentType } from '@angular/http';

import { saveAs } from 'file-saver';

import * as _ from 'lodash';
import { Provider } from '../classes/provider';
import { Auth } from '../services/auth.service';

var Moment = require('moment');




@Component({
  selector: 'login-attempts',
  templateUrl: './login-attempts.component.html',
  styleUrls: ['./login-attempts.component.css']
})

/**
 * This component needs the logic of the table and the pagination
 * from UsersComponent thats why the LoginAttempt objects
 * are saved in the 'users' array.
 */
export class LoginAttemptsComponent extends UsersComponent {

  constructor(
    protected router: Router,
    protected loginAttemptService: LoginAttemptService,
    protected providerSevice: ProviderService,
    protected requestService: RequestService,
    protected auth: Auth) { super(router, loginAttemptService, providerSevice); }

  fromDownload: Date;
  toDownload: Date;
  documentNumber: string;
  email: string;
  succesfulSteps: string;
  fromDate: Date;
  toDate: Date;
  selectedProvider:Provider
  selectedProviderIndex:string
  hasReportsPermission:boolean = false;

  protected getUserString(): string {

    return 'loginAttempt';
  };

  protected getUsersString(): string {

    return 'loginAttempts';
  };

  ngOnInit(): void {
    this.getProviders()
    this.hasReportsPermission = this.auth.hasReportsPermission();
  }

  getUsers(params) {
    params["from"] = Moment().subtract('days',1).format("DD-MM-YYYY")
    params["to"] = Moment().format("DD-MM-YYYY")
    delete params["limit"]
    this.loginAttemptService.get(params)
      .then(users => {
        this.users = users
        this.users = this.parseProvider(this.users)
        this.users = this.createdAt(this.users)
        this.haveUsers = this.users.length === this.usersPerGet
        this.noMatchesAlert = this.users.length === 0
        this.configPages();
        this.loading = false;
        this.timesSkipped++;
      })
  }

  parseProvider(users){
    users.forEach(loginAttempt => {
      if (!loginAttempt.provider){
        loginAttempt.provider = {name:"-",id:"-"}
      }
    });
    return users
  }

  createdAt(users: any[]) {
    for (let i = 0; i < users.length; i++) {
      users[i].createdAt = Moment(users[i].createdAt).format("DD/MM/YYYY HH:mm:ss")
    }
    return users
  }

  getParams(params):any{
    if (this.email) params["email"]=this.email
    if (this.documentNumber) params["documentNumber"]=this.documentNumber
    if (this.fromDate) params["from"]=Moment(this.fromDate).format("DD-MM-YYYY")
    if (this.toDate) params["to"]=Moment(this.toDate).format("DD-MM-YYYY")
    if (this.succesfulSteps) {
      if (this.succesfulSteps=="1") params["firstStep"]=false
      else if (this.succesfulSteps=="2") {
        params["firstStep"]=true
        params["secondStep"]=false
      }
      else if (this.succesfulSteps=="3") params["secondStep"]=true
    }
    if (this.selectedProvider){
      params["provider"]=this.selectedProvider.id
    }
    return params
  }

  needMoreUsers(params) {
    var params = this.getParams(params)
    this.timesSkipped++;
    let i = 0;
    this.loginAttemptService.get(params)
      .then(users => {
        this.haveUsers = users.length === this.usersPerGet
        if (0 < users.length) {
          users = this.createdAt(users)
          users = this.parseProvider(users)
          for (i; i < users.length; i++) {
            this.users.push(users[i])
          }
          this.noMatchesAlert = users.length === 0
          this.configPages();
        }
      })
  }

  applyFilter(){
      this.noMatchesAlert = false;

      this.currentPage = 0
      this.loading = true;
      let params = {};
      params['limit'] = this.usersPerGet;
      params = this.getParams(params)

      this.userService.get(params).then((users: any[]) => this.users = users)
          .then(() => {
              this.haveUsers = this.users.length === this.usersPerGet
              this.loading = false;
              this.configPages()
              this.users = this.createdAt(this.users)
              this.users = this.parseProvider(this.users)
              this.timesSkipped = 1;
              this.noMatchesAlert = this.users.length === 0;
          })
  }

  resetFilter(){
    this.documentNumber=undefined;
    this.email= undefined;
    this.succesfulSteps= undefined;
    this.fromDate=undefined;
    this.toDate= undefined;
    this.timesSkipped = 0
    this.currentPage = 0
    this.noMatchesAlert = false;
    this.getUsers({ limit: this.usersPerGet })
  }


  download() {
    var params = this.getParams({})
    if (this.fromDate){
      var from = Moment(this.fromDate).format("DD-MM-YYYY")
      params["from"]=from
    }
    if (this.toDate){
      var to = Moment(this.toDate).format("DD-MM-YYYY")
      params["to"]=to
    }
    var requestParams = {
      method: 'get',
      urlKey: 'logginAtemptReport',
      urlQueryParams:params,
      asObservable: true,
      responseType: ResponseContentType.Blob
    }

    this.requestService.makeRequest(requestParams).subscribe(
      (response) => {
        var headers = response.headers;
        var blob = new Blob([response._body], { type: headers.get('Content-type') });
        var filename = 'login-attempts('+from+'_'+to+').xlsx';
        saveAs(blob, filename);
      });

  }

  providerChanged(event){
    this.selectedProvider = this.providers[this.selectedProviderIndex]
    console.log(this.selectedProvider)
  }


}



// WEBPACK FOOTER //
// ./src/app/login-attempts/login-attempts.component.ts